import { render, staticRenderFns } from "./FieldFile.vue?vue&type=template&id=093d88d2&scoped=true"
import script from "./FieldFile.vue?vue&type=script&lang=js"
export * from "./FieldFile.vue?vue&type=script&lang=js"
import style0 from "./FieldFile.vue?vue&type=style&index=0&id=093d88d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d88d2",
  null
  
)

export default component.exports